var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n      "+_vm._s(_vm.$t('studentScoringComponentEntry.pageTitle'))+"\n    ")]),_c('ts-breadcrumb',{attrs:{"items":[
        { text: _vm.$t('toHomePage'), href: '/' },
        {
          text: _vm.$t('studentScoringComponentEntry.pageTitle'),
          href: '/student-scoring-entries'
        },
        {
          text: _vm.$t('create'),
          active: true
        }
      ]}})],1),_c('ts-card',[_c('ts-card-wrapper',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ts-loading-banner',{attrs:{"loading":_vm.loading}},[_c('filter-component',{attrs:{"class-operations":_vm.classes},on:{"acStatusChange":_vm.onStatusChange},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)]),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[_c('student-list',{ref:"studentlist",attrs:{"class-operations":_vm.classes},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }